import { toast } from 'sonner';

/**
 * Enregistre le service worker (production seulement : en développement, un
 * cache entre Vite et le navigateur ferait servir du code périmé).
 *
 * Quand une nouvelle version est déployée, on ne recharge pas d'office — un
 * formulaire en cours serait perdu. Un message propose « Mettre à jour ».
 */
export function enregistrerServiceWorker() {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      // On ne recharge que si l'utilisateur a demandé la mise à jour : au premier
      // passage, `clients.claim()` déclenche aussi `controllerchange`.
      let miseAJourDemandee = false;
      const inscription = await navigator.serviceWorker.register('/sw.js');

      const proposer = (enAttente: ServiceWorker) => {
        toast('Nouvelle version de FCONNECT disponible', {
          duration: Infinity,
          action: {
            label: 'Mettre à jour',
            onClick: () => {
              miseAJourDemandee = true;
              enAttente.postMessage('SKIP_WAITING');
            },
          },
        });
      };

      if (inscription.waiting && navigator.serviceWorker.controller) proposer(inscription.waiting);
      inscription.addEventListener('updatefound', () => {
        const nouveau = inscription.installing;
        nouveau?.addEventListener('statechange', () => {
          // Sans contrôleur, c'est la toute première installation : rien à proposer.
          if (nouveau.state === 'installed' && navigator.serviceWorker.controller) proposer(nouveau);
        });
      });

      let recharge = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (recharge || !miseAJourDemandee) return;
        recharge = true;
        window.location.reload();
      });

      // Une app installée reste ouverte des jours : vérifier de temps en temps.
      window.setInterval(() => inscription.update().catch(() => undefined), 60 * 60 * 1000);
    } catch {
      /* sans service worker, le site marche comme avant */
    }
  });
}
